import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { statusObj } from 'src/app/dummy/status';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { DataService } from 'src/app/services/data.service';
import { ISubject } from 'src/app/interfaces/country';
import { pageKey } from 'src/app/services/mapping.service';
import { AuthService } from 'src/app/auth/auth.service';
import { List } from 'src/app/stores/administrator/list.store';
import { AuthStore } from 'src/app/stores/auth/auth.store';

@Component({
  selector: 'app-add-subject',
  templateUrl: './add-subject.component.html',
  styleUrls: ['./add-subject.component.scss']
})
export class AddSubjectComponent implements OnInit {
  @ViewChild('focusInput', { static: false }) inputEl: ElementRef;

  form: FormGroup;
  code: AbstractControl;
  name: AbstractControl;
  khmerName: AbstractControl;
  description: AbstractControl;
  program: AbstractControl;

  SUBJECTTYPES = null;
  constructor(public dialogRef: MatDialogRef<AddSubjectComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public auth: AuthStore,
    public ds: DataService,
    private snackBar: MatSnackBar,
    public store: List
  ) { }

  buildForm(): void {
    this.form = this.fb.group({
      code: [null, Validators.compose([Validators.required])],
      name: [null, Validators.required],
      khmerName: [null],
      description: [null],
      program: [this.data, Validators.required]
    });
    this.code = this.form.controls['code'];
    this.name = this.form.controls['name'];
    this.description = this.form.controls['description'];
    this.khmerName = this.form.controls['khmerName'];
    this.program = this.form.controls['program'];
  }

  async ngOnInit() {
    this.buildForm();
    this.SUBJECTTYPES = await this.store.fetchList(this.ds.adprogramCollectRef())
  }

  compareObjects(o1: any, o2: any): boolean {
    return o1 && o2 ? o1.key === o2.key : o1 === o2;
  }

  create(f: any, isNew) {
    if (this.form.valid) {
      const { code, khmerName, description, program, name } = f;
      const { levelKey, degreeKey } = program;
      const courseCode = code.replace(/[^\w\s]/gi, '')
      const item:any = {
        key: this.ds.createId(),
        page_key: pageKey(),
        created_date: new Date(),
        created_by: this.ds.userRef().doc(`${this.auth.user.uid}`).ref,
        isDeleted: false,
        code: courseCode,
        name: name,
        keyword:`${name}`.toUpperCase() + ' ' + `${khmerName}`.toUpperCase(),
        khmerName: khmerName,
        description: description,
        programKey: program.key,
        programRef: this.ds.adprogramCollectRef().doc(`${program.key}`).ref,
        // levelKey: levelKey,
        // levelRef: this.ds.levelRef().doc(`${levelKey}`).ref,
        // degreeKey: degreeKey,
        // degreeRef: this.ds.degreeRef().doc(`${degreeKey}`).ref,
        lookup: `${name}`.toUpperCase(),
        status: statusObj.active
      };

      this.store.save(this.ds.subjectRef(), item, (success, error) => {
        if (success) {
          if (!isNew) {
            this.dialogRef.close();
          }
          this.snackBar.open('Subject has been created successfully.', 'done', { duration: 2000 });
          this.form.reset();
          this.form.patchValue({
            program
          });
          this.inputEl.nativeElement.focus();
        } else {
          this.snackBar.open(error, 'Error');
        }
      });
    }
  }

}
